// 英文译文 · 用户管理 / 系统设置 / 平台超管(公司管理 · 审计)/ 总览 / 订单链路反查 / 共用下拉选项(api/enums.ts)· key = 代码里的中文原文,一字不差
export default {
  // ── 角色 / 账号状态 / 页面权限档位 ──
  "公司管理员": "Company Admin",
  "管理员": "Admin",
  "操作员": "Operator",
  "冻结": "Blocked",
  "不可见": "Hidden",
  "只看": "View only",
  "可操作": "Full access",

  // ── 用户管理(views/tenant/Users.vue)──
  "本公司账号管理": "Company Accounts",
  "+ 新建账号": "+ New Account",
  "新建账号": "New Account",
  "编辑账号": "Edit Account",
  "页面权限": "Page Permissions",
  "最后登录": "Last Login",
  "全部可操作": "All: Full access",
  "全部只看": "All: View only",
  "全部不可见": "All: Hidden",
  "全部只看(默认)": "All: View only (default)",
  "可操作 {w} · 只看 {r} · 不可见 {n}": "Full access {w} · View only {r} · Hidden {n}",
  "照抄某账号的权限": "Copy from account…",
  "已照抄 {name} 的权限 · 可以再微调": "Copied permissions from {name} · You can fine-tune them",
  "账号必填 · 密码 8 位以上": "Username is required · Password must be at least 8 characters",
  "新密码 8 位以上": "New password must be at least 8 characters",
  "已保存 · 密码已重置 · 对方刷新页面后生效": "Saved · Password reset · Takes effect after the user refreshes the page",
  "已保存 · 对方刷新页面后生效": "Saved · Takes effect after the user refreshes the page",
  "确认将 {name} 切换为 启用?": "Enable {name}?",
  "确认将 {name} 切换为 停用?": "Disable {name}?",
  "公司管理员拥有全部页面的全部操作,还能管理账号。": "Company admins have full access to every page and can also manage accounts.",
  "账号建成后不可修改 · 停用即可": "Usernames can't be changed after creation · Disable the account instead",
  "「只看」能打开页面、看数据、导出和打印;「可操作」还能新建、编辑、提交、作废。保存后对方刷新页面即生效。": "\"View only\" can open the page, view data, export and print; \"Full access\" can also create, edit, submit and void. Takes effect after the user refreshes the page.",
  "重置密码": "Reset Password",
  "留空 = 不改密码 · 填了必须 ≥ 8 位": "Leave empty to keep the current password · At least 8 characters if filled in",
  "重置后本人下次登录需用新密码 · 建议告知本人。": "After a reset, the user must log in with the new password · Let them know.",

  // ── 账号无权限落地页(views/tenant/NoAccess.vue)──
  "暂无可访问的页面": "No Accessible Pages",
  "你的账号还没有开通任何页面 · 请联系公司管理员在「用户管理」里开通": "Your account doesn't have access to any pages yet · Ask your company admin to grant access in \"Users\"",

  // ── 系统设置(views/tenant/Settings.vue)──
  "审批人 · 公司资料 · 默认规则 · 只有公司管理员能改": "Approvers · Company Profile · Default Rules · Only company admins can change these",
  "审批设置": "Approval Settings",
  "指定审批人后,": "Once an approver is set, ",
  "只有他": "only that person",
  "能审批 / 驳回这种单据(本公司任何账号都可以,有「只看」权限就能审)。": " can approve / reject this type of document (any account in this company can be chosen — \"View only\" access is enough).",
  "审批人自己提交的单由": "Documents submitted by the approver are approved by the ",
  "备用审批人": "Backup Approver",
  "审;没设备用审批人时,审批人本人不能提交。": "; if there is no backup approver, the approver cannot submit documents themselves.",
  "不指定 = 本公司任一管理员(提交人除外)都能审。改完后还没审的单也按新设置走。": "Not set = any admin of this company (except the submitter) can approve. Changes also apply to documents not yet approved.",
  "单据": "Document",
  "(未指定)": "(Not set)",
  "现在的规则": "Current Rule",
  "最近修改": "Last Modified",
  "修改": "Change",
  "任一管理员(提交人除外)": "Any admin (except the submitter)",
  "付款申请": "Payment Requests",
  "供应商成本价": "Supplier Cost Prices",
  "供应商合同": "Supplier Contracts",
  "「{label}」审批人": "Approver for \"{label}\"",
  "审批人需要能看到「{page}」页面(只看就行);灰掉的账号看不到这个页面,先去用户管理里开。": "The approver must be able to see the \"{page}\" page (View only is enough); greyed-out accounts can't see it — grant access in Users first.",
  "不指定(任一管理员)": "Not set (any admin)",
  "可不设": "Optional",
  "先选审批人,再选备用审批人": "Select an approver before choosing a backup approver",
  "备用审批人不能和审批人是同一个人": "The backup approver can't be the same person as the approver",
  "已保存「{label}」审批人 · 还没审的单也按新设置走": "Saved the approver for \"{label}\" · Documents not yet approved also follow the new setting",
  "公司资料": "Company Profile",
  "(公司名称和代号由平台管理员维护)": " (company name and code are managed by the platform admin)",
  "公司英文名": "Company Name (English)",
  "印在发票 / 装箱单卖方栏": "Printed in the seller section of invoices / packing lists",
  "公司地址": "Company Address",
  "英文地址": "Address (English)",
  "联系电话": "Contact Phone",
  "联系邮箱": "Contact Email",
  "入库运费分摊": "Inbound Freight Allocation",
  "按重量": "By weight",
  "按金额": "By amount",
  "按数量": "By quantity",
  "采购单没单独选时用这个默认值;已分摊过的单不会自动重算": "Used when a PO doesn't set its own method; POs already allocated are not recalculated automatically",

  // ── 安全加强模式(平台超管按公司开关)──
  "安全加强": "Enhanced Security",
  "已开启": "On",
  "未开启": "Off",
  "开启后:该公司所有账号下次登录须输动态码(首次扫码绑定),密码不合规或满 365 天的必须先改。处理亚马逊数据的公司需开启。": "When enabled, every account in this company must enter a one-time code at next login (scan the QR to enroll the first time), and passwords that are non-compliant or older than 365 days must be changed first. Required for companies that process Amazon data.",

  // ── 平台超管 · 公司管理(views/platform/Tenants.vue)──
  "加载失败": "Failed to load",
  "公司(租户)管理": "Companies (Tenants)",
  "+ 新建公司": "+ New Company",
  "新建公司": "New Company",
  "编辑公司": "Edit Company",
  "公司代号": "Company Code",
  "公司名": "Company Name",
  "套餐": "Plan",
  "套餐(可空)": "Plan (optional)",
  "账号数": "Accounts",
  "停用原因": "Suspension Reason",
  "创建": "Create",
  "公司代号 / 名称必填 · 初始管理员密码 8 位以上": "Company code / name are required · Initial admin password must be at least 8 characters",
  "已创建 · 该公司初始管理员账号也已生成": "Created · The company's initial admin account has been created too",
  "公司名必填": "Company name is required",
  "已重置 {name} 的密码 · 请告知本人": "Password for {name} has been reset · Please let them know",
  "将 {name} 改为 公司管理员?": "Make {name} a Company Admin?",
  "将 {name} 改为 操作员?": "Make {name} an Operator?",
  "确认停用 {name}?停用后该公司账号无法登录": "Suspend {name}? Accounts of this company won't be able to log in",
  "停用公司": "Suspend Company",
  "停用原因(可选)": "Reason (optional)",
  "小写英文 / 数字 / 短横线 · 2-32 位": "Lowercase letters / digits / hyphens · 2-32 chars",
  "英文短标识符 · URL/日志/JWT 里用 ·": "Short English identifier · Used in URLs / logs / JWT ·",
  "不能中文。": "No Chinese characters.",
  "例:香港山川→": "e.g. Shanchuan HK → ",
  ",深圳司南→": ", Sinan Shenzhen → ",
  ",惠州添来→": ", Tianlai Huizhou → ",
  "。建成后不可改。": ". Cannot be changed once created.",
  "业务方看到的展示名 · 可中文": "Display name users see · Chinese allowed",
  "业务方看到的展示名": "Display name users see",
  "业务方在系统里看到的名字 · 如\"香港山川\"·\"CraftKitties Ltd\"。": "The name users see in the system · e.g. \"香港山川\" · \"CraftKitties Ltd\".",
  "trial(试用)": "trial",
  "active(正式)": "active",
  "初始公司管理员账号": "Initial Company Admin Account",
  "公司代号建成后": "Once created, the company code ",
  "不可修改": "cannot be changed",
  " · 换 slug 需要新建公司再迁移。": " · To change the slug, create a new company and migrate.",
  "单据抬头 · 印在发票等对外单据上": "Document Header · Printed on invoices and other external documents",
  "英文名": "English Name",
  "出口/商业发票用 · 如 Shanchuan (HK) Ltd.": "For export / commercial invoices · e.g. Shanchuan (HK) Ltd.",
  "中文地址": "Chinese address",
  "地址(英文)": "Address (English)",
  "跨境单据用": "For cross-border documents",
  "BR 号 / 统一社会信用代码 / VAT No.": "BR No. / Unified Social Credit Code / VAT No.",
  "这几项留空的话,发票抬头只有公司名 —— 客户和报关行核对不了卖方身份。": "If these are left empty, the invoice header shows only the company name — customers and customs brokers can't verify the seller.",
  "采购单整单运费分到每个单品的默认算法 · 单张采购单可以单独改。按重量时有产品缺毛重/净重,该单整单改按金额。": "Default method for allocating a PO's freight across its items · Can be changed per PO. When allocating by weight and a product lacks gross / net weight, the whole PO is allocated by amount instead.",
  "停用请用列表里的【停用】按钮 · 需要填原因。": "To suspend, use the \"Disable\" button in the list · A reason is required.",
  "超管代管该公司账号": "Platform admin managing this company's accounts",
  "此操作会写入平台审计流水 · 重置密码后请": "These actions are recorded in the platform audit log · After resetting a password, ",
  "线下告知": "tell the user offline",
  "本人 · 不要在群里发密码。": " · Never post passwords in group chats.",
  "换员": "Make Operator",
  "换管": "Make Admin",
  "重置账号密码": "Reset Account Password",
  "即将重置": "About to reset the password of",
  "的密码 · 保存后本人须用新密码登录。": "· After saving, the user must log in with the new password.",
  "新密码": "New Password",
  "≥ 8 位 · 建议含符号": "≥ 8 characters · Symbols recommended",
  "确认重置": "Confirm Reset",

  // ── 平台审计(views/platform/AuditLog.vue)──
  "平台审计流水": "Platform Audit Log",
  "action(如 tenant.create)": "action (e.g. tenant.create)",
  "租户": "Tenant",
  "用户": "User",
  "对象类型": "Target Type",
  "对象 ID": "Target ID",

  // ── 总览(views/tenant/dashboard/Overview.vue · api/dashboard.ts)──
  "本公司总览": "Company Overview",
  "月度数据 · 更新到今日": "Month to date · Updated through today",
  "还没有业务数据": "No business data yet",
  "建议从产品库、供应商库、客户库开始录入,然后再录销售订单 / 采购订单": "Start by adding products, suppliers and customers, then enter sales orders / purchase orders",
  "去产品库": "Go to Products",
  "去供应商库": "Go to Suppliers",
  "去客户库": "Go to Customers",
  "月度收入": "Revenue (MTD)",
  "月度支出": "Expenses (MTD)",
  "本月新订单": "New Orders This Month",
  "笔": "orders",
  "待审批": "Pending Approval",
  "件": "items",
  "最近销售订单": "Recent Sales Orders",
  "查看全部": "View All",
  "订单号": "Order No.",
  "暂无销售订单": "No sales orders",
  "近期收款": "Recent Receipts",
  "收款单号": "Receipt No.",
  "到账日": "Received Date",
  "暂无收款": "No receipts",
  "未对账": "Unmatched",
  "已对账": "Matched",
  "有差异": "Discrepancy",
  "待审批 · 全部类型混合": "Pending Approval · All Types",
  "点击行跳转到对应审批页": "Click a row to open its approval page",
  "事由 / 收款人": "Purpose / Payee",
  "暂无待审批": "Nothing pending approval",
  "本月现金位置": "Cash Position This Month",
  "账户": "Account",
  "收": "In",
  "付": "Out",
  "本月尚无资金流水": "No cash movements this month",
  "TOP 5 客户": "Top 5 Customers",
  "按销售额": "By sales",
  "订单": "Orders",
  "本月尚无销售": "No sales this month",
  "TOP 5 供应商": "Top 5 Suppliers",
  "按付款额": "By payments",
  "笔数": "Count",
  "本月尚无付款": "No payments this month",
  "费用": "Expense",
  "已确认": "Confirmed",
  "待上游确认": "Awaiting Upstream",
  "待发货": "Awaiting Shipment",
  "已发货": "Shipped",
  "已签收": "Delivered",

  // ── 订单链路反查(views/tenant/dashboard/ChainTrace.vue)──
  "请输入查询条件": "Please enter a search term",
  "出货": "Shipment",
  "从任一编号反查全链 · 客户 → 销售订单 → 出货 → 货代 → 收款 / 退款": "Trace the full chain from any number · Customer → Sales Order → Shipment → Forwarder → Receipt / Refund",
  "查订单在贸易链路上到哪一步了": "Find out where an order is in the trade chain",
  "客服看客户投诉、财务对账、异常排查都从这里进": "Start here for customer complaints, finance reconciliation and troubleshooting",
  "输入订单号 / 客户名 / 出货单号 / 收款号 / 退款号": "Order no. / customer name / shipment no. / receipt no. / refund no.",
  "追踪": "Trace",
  "在上方输入编号追踪链路": "Enter a number above to trace its chain",
  "支持 SO / SH / RCV / PAY / RF 前缀 · 也可以输入客户名模糊搜索": "Supports SO / SH / RCV / PAY / RF prefixes · You can also search by part of a customer name",
  "未找到匹配记录": "No matching records",
  "链路节点": "Chain Nodes",
  "命中类型": "Matched type",
  "链上无节点": "No nodes in the chain",
  "SKU 明细": "SKU Lines",
  "无明细行": "No line items",
  "节点详情": "Node Details",
  "打开完整页": "Open full page",
  "跨公司 · 仅显示共享信息": "Cross-company · shared info only",
  "该节点无更多信息": "No further details for this node",
  "摘要": "Summary",
  "下单日": "Order date",
  "物流单号": "Tracking no.",
  "目的国": "Destination",
  "退款日": "Refund date",
  "单重(g)": "Unit weight (g)",

  // ── 共用下拉选项(api/enums.ts)· 供应商 / 客户分类 ──
  "五金": "Hardware",
  "木材": "Wood",
  "包装": "Packaging",
  "物流": "Logistics",
  "服务": "Services",
  "内部关联": "Internal Affiliate",
  "原材料": "Raw Materials",
  "成品": "Finished Goods",
  "配件": "Accessories",
  "电子": "Electronics",
  "纺织": "Textiles",
  "化工": "Chemicals",
  "食品": "Food",
  "其他": "Other",
  // ── 付款条款 ──
  "月结 30 天": "Net 30",
  "月结 60 天": "Net 60",
  "月结 90 天": "Net 90",
  "预付 30%": "30% Prepaid",
  "预付 50%": "50% Prepaid",
  "全额预付": "100% Prepaid",
  "货到付款": "Cash on Delivery",
  "见货付款": "Payment on Inspection",
  // ── 单位 ──
  "pcs · 件": "pcs",
  "box · 箱": "box",
  "pair · 对": "pair",
  "set · 套": "set",
  "pack · 包": "pack",
  "dozen · 打": "dozen",
  "kg · 千克": "kg",
  "g · 克": "g",
  "l · 升": "l",
  "ml · 毫升": "ml",
  "m · 米": "m",
  "cm · 厘米": "cm",
  "roll · 卷": "roll",
  "sheet · 张": "sheet",
  // ── 国家 ──
  "🇨🇳 CN · 中国": "🇨🇳 CN · China",
  "🇭🇰 HK · 香港": "🇭🇰 HK · Hong Kong",
  "🇹🇼 TW · 台湾": "🇹🇼 TW · Taiwan",
  "🇺🇸 US · 美国": "🇺🇸 US · United States",
  "🇨🇦 CA · 加拿大": "🇨🇦 CA · Canada",
  "🇬🇧 GB · 英国": "🇬🇧 GB · United Kingdom",
  "🇩🇪 DE · 德国": "🇩🇪 DE · Germany",
  "🇫🇷 FR · 法国": "🇫🇷 FR · France",
  "🇮🇹 IT · 意大利": "🇮🇹 IT · Italy",
  "🇪🇸 ES · 西班牙": "🇪🇸 ES · Spain",
  "🇳🇱 NL · 荷兰": "🇳🇱 NL · Netherlands",
  "🇧🇪 BE · 比利时": "🇧🇪 BE · Belgium",
  "🇵🇱 PL · 波兰": "🇵🇱 PL · Poland",
  "🇵🇹 PT · 葡萄牙": "🇵🇹 PT · Portugal",
  "🇸🇪 SE · 瑞典": "🇸🇪 SE · Sweden",
  "🇳🇴 NO · 挪威": "🇳🇴 NO · Norway",
  "🇩🇰 DK · 丹麦": "🇩🇰 DK · Denmark",
  "🇫🇮 FI · 芬兰": "🇫🇮 FI · Finland",
  "🇨🇭 CH · 瑞士": "🇨🇭 CH · Switzerland",
  "🇦🇹 AT · 奥地利": "🇦🇹 AT · Austria",
  "🇮🇪 IE · 爱尔兰": "🇮🇪 IE · Ireland",
  "🇬🇷 GR · 希腊": "🇬🇷 GR · Greece",
  "🇨🇿 CZ · 捷克": "🇨🇿 CZ · Czechia",
  "🇭🇺 HU · 匈牙利": "🇭🇺 HU · Hungary",
  "🇯🇵 JP · 日本": "🇯🇵 JP · Japan",
  "🇰🇷 KR · 韩国": "🇰🇷 KR · South Korea",
  "🇸🇬 SG · 新加坡": "🇸🇬 SG · Singapore",
  "🇲🇾 MY · 马来西亚": "🇲🇾 MY · Malaysia",
  "🇹🇭 TH · 泰国": "🇹🇭 TH · Thailand",
  "🇻🇳 VN · 越南": "🇻🇳 VN · Vietnam",
  "🇮🇩 ID · 印尼": "🇮🇩 ID · Indonesia",
  "🇵🇭 PH · 菲律宾": "🇵🇭 PH · Philippines",
  "🇮🇳 IN · 印度": "🇮🇳 IN · India",
  "🇦🇺 AU · 澳大利亚": "🇦🇺 AU · Australia",
  "🇳🇿 NZ · 新西兰": "🇳🇿 NZ · New Zealand",
  "🇲🇽 MX · 墨西哥": "🇲🇽 MX · Mexico",
  "🇧🇷 BR · 巴西": "🇧🇷 BR · Brazil",
  "🇨🇱 CL · 智利": "🇨🇱 CL · Chile",
  "🇦🇷 AR · 阿根廷": "🇦🇷 AR · Argentina",
  "🇦🇪 AE · 阿联酋": "🇦🇪 AE · United Arab Emirates",
  // 2026-09-27 跨公司推单
  "手动": "Manual",
  "在销售订单里勾选 / 点「推给下游」": "Select orders / click \"Push downstream\" in Sales Orders",
  "确认后自动推": "Auto-push on confirm",
  "销售单点「确认」时自动推给默认的内部供应商": "When a sales order is confirmed, push it to the default internal supplier",
  "新单进来就自动推": "Auto-push new orders",
  "平台拉到新单、或上游公司推来新单时,自动确认并推下去": "When a new platform order is pulled or an upstream company pushes one in, confirm and push it on automatically",
  "跨公司推单": "Inter-company Push",
  "本公司代号:{code}": "Our company code: {code}",
  "销售单推给下一家公司:本公司按来货价建采购单,对方自动建销售单;对方发货后运单号一路回传。": "Push sales orders to the next company: we create a PO at the supply price and they get a sales order automatically; once they ship, the tracking number flows back.",
  "要推给谁:在【供应商库】建一个供应商,勾「内部公司」并填对方公司代号;对方要在它的【客户库】建本公司(内部公司,代号填本公司代号)。": "To set up a target: create a supplier in Suppliers, tick \"Internal company\" and enter their company code; they must add us in their Customers (internal, with our company code).",
  "自动推": "Auto-push",
  "默认推给": "Default target",
  "亚马逊": "Amazon",
  "按渠道推给": "Target by channel",
  "走默认": "Use default",
  "平台拉的单按平台,手工录的单按录单时选的「来源渠道」。没指定的渠道、来源选「其他」的单走「默认推给」;默认也没设、内部供应商又不止一家时,要人手工选推给谁。": "Pulled orders use their platform; manual orders use the source channel chosen when entered. Channels without a target, and orders with source \"Other\", go to the default target; with no default and more than one internal supplier, someone has to choose the target by hand.",
  "只有一个内部供应商时可不选": "Optional if there is only one internal supplier",
  "内部供应商": "Internal Supplier",
  "对方公司": "Their Company",
  "生效来货价": "Active Prices",
  "配置检查": "Setup Check",
  "可以推": "Ready",
  "还没有内部供应商": "No internal suppliers yet",
  // 2026-09-29 安全加强模式(MFA + 密码规则)
  "至少 {n} 位": "At least {n} characters",
  "你的密码不符合公司安全规则、已满 365 天或刚被管理员重置,请先修改再继续使用": "Your password doesn't meet the company security rules, is over 365 days old, or was just reset by an admin. Please change it before continuing.",
  "密码规则:{rules}": "Password rules: {rules}",
  "请先修改密码": "Please change your password first",
  "请输入 6 位数字动态码": "Please enter the 6-digit code",
  "验证已超时 · 请重新输入密码登录": "Verification timed out · please log in with your password again",
  "第一次登录:绑定手机动态码": "First login: set up your authenticator app",
  "手机上装一个验证器 App:Microsoft Authenticator 或 Google Authenticator(应用商店搜得到)": "Install an authenticator app on your phone: Microsoft Authenticator or Google Authenticator (available in the app store)",
  "打开 App,点「+」→「扫描二维码」,扫下面这个码": "Open the app, tap \"+\" → \"Scan a QR code\", and scan the code below",
  "输入 App 上显示的 6 位数字": "Enter the 6-digit code shown in the app",
  "扫不了可以在 App 里手动输入密钥:": "Can't scan? Enter this key manually in the app: ",
  "请输入手机验证器 App 上的 6 位动态码": "Enter the 6-digit code from your authenticator app",
  "6 位动态码": "6-digit code",
  "验证并登录": "Verify and log in",
  "← 返回重新输入密码": "← Back to password",
  "打开后,本公司所有账号(包括你自己)下次登录都要输手机动态码,第一次登录扫码绑定;密码不合规或满 365 天的,登录后必须先改。确定打开?": "Once enabled, every account in this company (including yours) must enter an authenticator code at next login, scanning a QR code the first time; passwords that don't meet the rules or are over 365 days old must be changed after login. Enable it?",
  "关掉后登录不再要动态码,密码规则回到至少 8 位。确定关掉?": "Once disabled, login no longer needs an authenticator code and the password rule goes back to at least 8 characters. Disable it?",
  "安全加强模式": "Enhanced Security",
  "已打开 · 大家下次登录生效": "Enabled · takes effect at everyone's next login",
  "已关闭": "Disabled",
  "已打开": "On",
  "未打开": "Off",
  "动态码已绑定 {n} / {total} 人": "Authenticator set up: {n} / {total}",
  "亚马逊 SP-API 数据保护要求。打开后:① 登录要输手机验证器 App(Microsoft / Google Authenticator)上的 6 位动态码,第一次登录扫码绑定;② 密码规则:{rules};③ 管理员重置的密码,本人下次登录必须先改;④ 动态码连错 5 次锁 15 分钟。丢了手机在【用户管理】里点「重置动态码」。": "Required by Amazon SP-API data protection. When on: ① login needs the 6-digit code from an authenticator app (Microsoft / Google Authenticator), set up by scanning a QR code the first time; ② password rules: {rules}; ③ passwords reset by an admin must be changed by the user at next login; ④ 5 wrong codes lock the account for 15 minutes. Lost phone? Use \"Reset authenticator\" in User Management.",
  "动态码": "Authenticator",
  "已绑定": "Set up",
  "下次登录要先改": "Must change at next login",
  "{at} 改过": "Changed {at}",
  "密码至少 {n} 位": "Password must be at least {n} characters",
  "密码要含特殊字符(比如 ! @ # $ % & *)": "Password must include a special character (e.g. ! @ # $ % & *)",
  "重置 {name} 的登录动态码?用于手机丢了 / 换手机:对方下次登录时重新扫码绑定。": "Reset {name}'s authenticator? Use this for a lost or new phone: they will scan a new QR code at next login.",
  "重置动态码": "Reset authenticator",
  "已重置 · 对方下次登录重新绑定": "Reset · they will set it up again at next login",
  "账号必填": "Username is required",
  "留空 = 不改密码 · 填了必须 ≥ {n} 位": "Leave empty to keep the password · otherwise ≥ {n} characters",
  "FBA 单": "FBA orders",
  "卖出时推链路记账": "Push the chain when sold (books only)",
  "不推,只留在本公司": "Don't push, keep in this company",
  "改成「卖出时推链路记账」?只有亚马逊仓里的货没在任何地方记过公司间买卖才这样用;已经开票结算过的、用 FBA 备货采购单备过的货会重复记账。确定?": "Switch to \"push the chain when sold\"? Only use this if the stock in Amazon warehouses was never booked between companies anywhere; stock already invoiced and settled, or restocked via FBA restock POs, would be booked twice. Continue?",
  "改成不推后,亚马逊 FBA 单卖出时只留在本公司,不再推给下一家。确定?": "After switching off, Amazon FBA orders stay with this company when sold and are no longer pushed downstream. Continue?",
  "亚马逊 FBA 卖出一单,按上面的路线推给下一家,只记账(下游不发货、不扣库存)· 只有亚马逊仓里的货没在任何地方记过公司间买卖才用;开着时不能提交 FBA 备货采购单(会重复记账)": "Each Amazon FBA sale is pushed downstream along the route above, books only (downstream doesn't ship or deduct stock) · only use this if the stock in Amazon warehouses was never booked between companies; while on, FBA restock POs can't be submitted (would double-book)",
  "FBA 单卖出时货早就在亚马逊仓、归本公司了,不推给下一家;公司间买卖在备货发往亚马逊时记(FBA 备货采购单)": "When an FBA order sells, the goods are already in the Amazon warehouse and belong to this company, so it isn't pushed downstream; the intercompany sale is booked when the restock ships to Amazon (FBA restock PO)",
  "「FBA 备货」= FBA 备货采购单默认下给谁(亚马逊自发货订单按「亚马逊」那一项走)。": "\"FBA restock\" = who FBA restock POs go to by default (Amazon merchant-fulfilled orders follow the \"Amazon\" setting).",
  "重置「{name}」的 API-Key?旧 Key 立即失效,EP 产品中心里要换成新的,否则调不通。": "Reset the API key of \"{name}\"? The old key stops working immediately; EP Product Center must switch to the new one or its calls will fail.",
  "开启后,EP 产品中心可以新建、修改、归档「{name}」所在公司产品库里的产品,并提交待审批的来货价。确定已经联调通过?": "Once enabled, EP Product Center can create, edit and archive products in this company's product library (\"{name}\") and submit purchase prices for approval. Has integration testing passed?",
  "改为只读后,EP 产品中心只能查,增删改会被拒绝。": "After switching to read-only, EP Product Center can only read; create / edit / delete will be refused.",
  "EP 拉本公司产品库,也能增删改": "EP reads this company's product library and can also create / edit / delete",
  "EP 还没调过": "EP hasn't called yet",
  "EP 产品中心:保存后生成本公司专属的 API-Key(只显示一次),连同对接说明发给 EP 开发。Key 只能看到、只能改本公司的产品库;新建先是只读,联调通过后点「开启回写」。": "EP Product Center: saving generates an API key for this company (shown only once); send it with the integration guide to the EP developers. The key can only see and change this company's product library. It starts read-only; click \"Enable write-back\" after integration testing passes.",
  "Key 请用加密方式单独发给 EP 开发(别贴群)· 接口说明见《跨境ERP-EP产品中心产品库对接说明》。": "Send the key to the EP developers separately over an encrypted channel (not in a group chat) · see the \"ERP – EP Product Center integration guide\" for the API.",
  "EP 产品中心": "EP Product Center",
  "EP 服务器的公网出口 IP,逗号隔开 · 留空 = 不限 IP(只认 API-Key)· EP 出口 IP 会变的话就留空": "Public egress IPs of the EP servers, comma-separated · blank = any IP (API key only) · leave blank if EP's egress IP changes",
  "全部复制": "Copy all",
  "浏览器不让自动复制 · 下面框里的内容点一下就全选了,按 Ctrl+C 复制": "The browser blocked automatic copying · click the box below to select everything, then press Ctrl+C",
} as Record<string, string>;
